/* eslint-disable react-hooks/exhaustive-deps */
import Icon from "@components/general/Icon";
import StepperResponsive from "@components/StepperResponsive";
import { IViewport } from "@config/appConfig";
import { AppAction, IAppAction } from "@misc/Action";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import { FC, Fragment, MouseEvent, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

export enum CreateStep { Search = 1, SelectFlight, PaxInfo, SpecialServices, PrePayment }

export interface IStep {
    stepNumber: number;
    icon: string;
    title?: string;
    url?: string;
    desc?: string;
    onClick?: () => void;
}

interface IStepperProps {
    steps: Array<IStep>;
    name: string;
    id: string;
}

const Stepper: FC<IStepperProps> = ({ steps, id, children }) => {
    const { push } = useHistory();
    const dispatch = useDispatch();
    const { small } = Config.get<IViewport>("viewport");
    const { currentStep, width } = useSelector((state: IAppState) => ({
        currentStep: state.currentStep,
        width: state.windowWidth
    }));
    const len = steps.length;

    useEffect(() => {
        const step = steps[currentStep - 1];
        if (step.url)
            push(step.url);
    }, [currentStep]);

    const onClick = (e: MouseEvent<HTMLElement>) => {
        const index = +(e.currentTarget.getAttribute("data-index") || 0);
        const step = steps[index];
        dispatch<IAppAction>({ type: AppAction.CurrentStep, payload: { currentStep: index + 1 } });
        if (step.onClick)
            step.onClick();
    }

    const stepHeaderContent = (step: IStep) => (
        <Fragment>
            <div className="step-circle" >
                <Icon name={step.icon} flipRtl={step.icon === "icon-airplane-takeoff" || step.icon === "icon-special-services"} />
            </div>
            <div className="step-title">{step.title}</div>
            <div className="step-bar-left" />
            <div className="step-bar-right" />
        </Fragment>
    );

    return (
        <div className="stepper">

            <div className="stepper-header">
                {
                    width > small ?
                        <div id={id} className="stepper-horizontal">
                            {
                                steps.map((step, index) => (
                                    step.url ?
                                        <Link
                                            id={step.title}
                                            key={index}
                                            to={step.url}
                                            data-index={index}
                                            className={`step ${index + 1 === currentStep ? "editing" : index + 1 < currentStep ? "done" : "pending"} `}
                                            style={{ width: (100 / len) + '%' }}
                                            onClick={onClick}
                                        >
                                            {stepHeaderContent(step)}
                                        </Link>
                                        :
                                        <div
                                            id={step.title}
                                            key={index}
                                            data-index={index}
                                            className={`step ${index + 1 === currentStep ? "editing" : index + 1 < currentStep ? "done" : "pending"} `}
                                            style={{ width: (100 / len) + '%' }}
                                            onClick={onClick}
                                        >
                                            {stepHeaderContent(step)}
                                        </div>
                                ))
                            }
                        </div>
                        :
                        <StepperResponsive steps={steps} currentStep={currentStep} />
                }
            </div>
            <div className="stepper-content">
                {children}
            </div>
        </div>
    )
}

export default Stepper;